import React from 'react'

export default function AboutMind() {
  return (
    <>
    <section className="aboutpage-mind">
        <img src="/image/aboutmind-big.webp" className="aboutmind-image" alt="About" loading="lazy"/>

        <div className="container">
            <div className="row justify-content-end">
                <div className="col-lg-6 col-md-6 col-sm-7">
                    <div className="aboutmind-box">
                        <img src="/image/aboutmind-small.webp" className="img-responsive" alt="About" loading="lazy"/>
                        <h2 className='heading'>"Our Vision: A State of Mind"</h2>
                    </div>
                </div>
            </div>
        </div>
    </section> 

    <section className="aboutmind-detail">
        <div className="container">
            <div className="row justify-content-end">
                <div className="col-lg-7 col-md-8">
                    <span>…stepping away from the noise. Rediscovering balance and gentle happiness.</span>
                    <p>Our founder’s vision is simple: to create sanctuaries where luxury serves a purpose—the purpose of restoration. Our mission is to blend the raw beauty of our locations with curated interiors and natural materials that touch the spirit. Whether it is a sunlit corner in Goa, a quiet jungle trail in Corbett, or a riverside meditation in Rishikesh, we design every space to uplift your spirit. Surrounded by refined details and quiet sophistication, we ensure your stay with us becomes a journey toward clarity, energy, and lasting peace.</p>
                </div>
            </div>
        </div>
    </section> 
    </>
  )
}
